import { Component, Input, ElementRef } from '@angular/core';

import * as _ from 'lodash';

import { Table } from './classes/table';
import { TableItem } from './classes/item';

@Component({
  selector: 'uex-table',
  templateUrl: './table.component.html',
  host: {
    class: 'uex-table'
  }
})
export class TableComponent {
  @Input() table: Table;

  constructor(
    public elementRef: ElementRef
  ) {}

  public get offsetTop(): number {
    return this.elementRef.nativeElement.offsetTop;
  }

  public update() {
    this.table.update();
  }

  public getSelectedData(): Array<any> {
    return this.table.getSelectedData(true);
  }

  public getData(): Array<any> {
    return this.table.getRawData();
  }

  public getDynamicData(): Array<TableItemObject> {
    return this.table.getData().map((rowData) => {
      const row_data = {};
      rowData.items.forEach((item) => {
        if (item.accessor) { row_data[item.accessor] = item; }
      });
      return row_data;
    });
  }

}

export interface TableItemObject {
  [key: string]: TableItem;
}
